function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Box, Card, Column, Popover, SegmentControl } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import { ColorPicker } from "../../../components/ColorPicker/ColorPicker";
import { ColorSelector } from "../../../components/ColorSelector/ColorSelector";
import stylesPrimary from "./PrimaryBackgroundColorPopup.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const PRESET_SOLID_COLORS = [colors.orange900, colors.orange800, colors.orange700, colors.orange500, colors.orange300, colors.orange50, colors.green900, colors.green800, colors.green700, colors.green500, colors.green300, colors.green50, colors.blue800, colors.blue700, colors.blue600, colors.blue500, colors.blue300, colors.blue50, colors.purple900, colors.purple800, colors.purple700, colors.purple500, colors.purple300, colors.purple50, colors.dark900, colors.dark800, colors.dark700, colors.dark500, colors.dark300, colors.dark100, colors.red970, colors.red950, colors.red900, colors.red700, colors.red500, colors.red300];

/** Predefined gradient [start, end] pairs. Max 12. UI gradient: -45° (135deg), color1 top-left, color2 bottom-right. */
const PRESET_GRADIENTS = [[colors.purple50, colors.purple300], [colors.purple50, colors.purple500], [colors.blue50, colors.blue300], [colors.blue50, colors.blue500], [colors.green50, colors.green300], [colors.green50, colors.green500], [colors.orange50, colors.orange300], [colors.orange50, colors.orange500], [colors.dark50, colors.dark200], [colors.dark70, colors.dark300], ['#E7E7FF', '#E7F5FF'], ['#F4ECFF', '#E7E7FF']];
export function PrimaryBackgroundColorPopup(props) {
  const {
    branding,
    hasError,
    onChange
  } = props;
  const start = branding.backgroundGradientStart;
  const end = branding.backgroundGradientEnd;
  const isSolid = start === end;
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTab, setActiveTab] = useState(isSolid ? 'solid' : 'gradient');
  const displayBackground = isSolid ? start : "linear-gradient(135deg, ".concat(start, " 0%, ").concat(end, " 100%)");
  function applySolid(color) {
    onChange(_objectSpread(_objectSpread({}, branding), {}, {
      backgroundGradientStart: color,
      backgroundGradientEnd: color
    }));
  }
  function applyGradient(color1, color2) {
    onChange(_objectSpread(_objectSpread({}, branding), {}, {
      backgroundGradientStart: color1,
      backgroundGradientEnd: color2
    }));
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ColorSelector, {
      withBorder: true,
      color: displayBackground,
      hasError: hasError,
      testid: "color-selector-primary-background",
      onClick: e => setAnchorEl(e.currentTarget)
    }), /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: !!anchorEl,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: -5,
        horizontal: 'right'
      },
      onClose: () => setAnchorEl(null),
      children: /*#__PURE__*/_jsx(Card, {
        className: stylesPrimary.popupCard,
        children: /*#__PURE__*/_jsxs(Column, {
          gap: 16,
          alignItems: "stretch",
          children: [/*#__PURE__*/_jsx(Box, {
            className: stylesPrimary.segmentControlWrapper,
            children: /*#__PURE__*/_jsx(SegmentControl, {
              options: [{
                value: 'gradient',
                label: 'Gradient',
                'data-testid': 'primary-bg-tab-gradient'
              }, {
                value: 'solid',
                label: 'Solid',
                'data-testid': 'primary-bg-tab-solid'
              }],
              value: activeTab,
              onChange: value => setActiveTab(value),
              variant: "text",
              "aria-label": "Primary background type",
              "data-testid": "primary-background-segment"
            })
          }), activeTab === 'gradient' ? /*#__PURE__*/_jsxs(Column, {
            gap: 16,
            className: stylesPrimary.tabContent,
            children: [/*#__PURE__*/_jsx(Box, {
              className: stylesPrimary.gradientGrid,
              children: PRESET_GRADIENTS.map((_ref, idx) => {
                let [c1, c2] = _ref;
                return /*#__PURE__*/_jsx(ColorSelector, {
                  withBorder: true,
                  color: "linear-gradient(135deg, ".concat(c1, " 0%, ").concat(c2, " 100%)"),
                  selected: start === c1 && end === c2,
                  testid: "gradient-preset-".concat(idx),
                  onClick: () => applyGradient(c1, c2)
                }, "".concat(c1, "-").concat(c2, "-").concat(idx));
              })
            }), /*#__PURE__*/_jsxs(Column, {
              gap: 12,
              children: [/*#__PURE__*/_jsx(ColorPicker, {
                colorAsSuffix: true,
                className: stylesPrimary.colorPickerFullWidth,
                inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                testid: "primary-bg-custom-color-1",
                label: "Custom color 1",
                color: start,
                displayColor: start,
                noMinWidth: true,
                onChange: c => applyGradient(c, end)
              }), /*#__PURE__*/_jsx(ColorPicker, {
                colorAsSuffix: true,
                className: stylesPrimary.colorPickerFullWidth,
                inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                label: "Custom color 2",
                testid: "primary-bg-custom-color-2",
                color: end,
                displayColor: end,
                noMinWidth: true,
                onChange: c => applyGradient(start, c)
              })]
            })]
          }) : /*#__PURE__*/_jsxs(Column, {
            gap: 16,
            className: stylesPrimary.tabContent,
            children: [/*#__PURE__*/_jsx(Box, {
              className: stylesPrimary.gradientGrid,
              children: PRESET_SOLID_COLORS.map((presetColor, idx) => /*#__PURE__*/_jsx(ColorSelector, {
                withBorder: true,
                color: presetColor,
                selected: presetColor.toLowerCase() === (start || '').toLowerCase(),
                testid: "solid-preset-".concat(idx),
                onClick: () => applySolid(presetColor)
              }, presetColor))
            }), /*#__PURE__*/_jsx(ColorPicker, {
              colorAsSuffix: true,
              className: stylesPrimary.colorPickerFullWidth,
              inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
              testid: "primary-bg-solid-custom",
              color: start,
              noMinWidth: true,
              label: "Custom color",
              displayColor: start,
              onChange: applySolid
            })]
          })]
        })
      })
    })]
  });
}